import React from "react";
import Wave from "react-wavify";
import contact from "../../Image/Contact/contact.svg";

const AboutContact = () => {
  return (
    <>
    <div className="relative overflow-hidden sm:top-[-20px] top-[-19px] z-10">
        <Wave fill="#fff" paused={false} style={{ display: "flex" }} options={{ height: 20, amplitude: 20, speed: 0.3, points: 5 }} className="relative min-w-[1920px] h-[28px] "/>
        <div className="bg-white py-10">
            <div className="container mx-auto px-4">
                <div className="flex flex-col lg:flex-row items-center">
                    <div className="lg:w-2/5 w-full mb-8 lg:mb-0 px-4">
                        <div className="flex justify-center"><img src={contact} alt="Contact" className="w-full max-w-md"/></div>
                    </div>
                    <div className="lg:w-3/5 w-full px-4">
                        <p className="text-xl font-semibold mb-4">Do you have any Queries ? We’re happy to help!</p>
                        <p className="text-sm sm:text-base mb-5 text-justify text-[#555555]">Welcome to <strong className="text-[#8A49D6]">KALATHIYA INFOTECH</strong> whereinnovation meets expertise. With a passion for technology anda commitment to excellence, we specialize in providingcutting-edge IT solutions tailored to meet the unique needs ofour clients. Our team of skilled professionals brings togethera wealth of experience and knowledge to deliver top-notchservices in software development, cybersecurity, cloudcomputing, and beyond. We strive for nothing less thanperfection, working tirelessly to ensure our clients stayahead in an ever-evolving digital landscape. Discover thedifference with KALATHIYA INFOTECH today.</p>
                        <p className="text-sm sm:text-base text-justify text-[#555555]">At <strong className="text-[#8A49D6]"> KALATHIYA INFOTECH</strong>, we are dedicated to providingexceptional service and support to our clients. Whether youhave a question about our products, need technical assistance,or want to explore partnership opportunities, we're here tohelp. Our experienced team is ready to assist you with anyinquiries you may have.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    </>
  );
};

export default AboutContact;
